<template>
  <div
    v-if="!$auth.check(['dashboard.accounts']) || isLeader == 3"
    class="development-message"
  >
    <div v-if="loading" class="overlay">
      <div><img class="spinner" src="loading.gif" alt="Loading data..." /></div>
    </div>
    <div
      v-if="!$auth.check(['dashboard.accounts'])"
      class="container-pull-zone"
    >
      <label class="dropdown-container-zone box-drop-zone" for="zoneSelect"
        >Selecione a Zona:</label
      >
      <select v-model="selectedZone" id="zoneSelect" @change="fetchCampaings">
        <option v-for="zone in zones" :key="zone.zone" :value="zone.zone">
          {{ zone.name }}
        </option>
      </select>
    </div>
    <div id="app">
      <MonthDropdown
        :selectedCampaignMonthFromParent="selectedCampaignMonth"
        @monthSelectedFilter="handleCampaignMonthSelected"
      />
    </div>
    <div id="app" class="app-camp">
      <div v-if="loading"></div>
      <div v-else-if="error">{{ error }}</div>
      <Slider v-else :items="campaignNames" v-model="selectedCampaign" />
    </div>
    <div v-if="selectedCampaignData.length > 0" class="campaign-container">
      <div
        v-for="(campaign, zIndex) in selectedCampaignData"
        :key="zIndex"
        class="campaign-box"
      >
        <div class="box">
          <div class="box-style text-style">
            <div class="text-box">
              <div class="box-content"><span class="smaller">Zona</span></div>
              <span class="box-content bigger">{{ campaign.zone }}</span>
              <div
                v-if="campaign.name.includes('Niv')"
                class="box-content-right values"
              >
                <div class="flex-container">
                  <div class="box-content">Objetivo</div>
                  <div class="box-content-right values box-no-pad-right-top">
                    {{
                      new Intl.NumberFormat("de-DE").format(
                        Math.round(campaign.target)
                      )
                    }}
                    &#8364;
                  </div>
                </div>
                <div class="flex-container">
                  <div class="box-content box-pad">Realizado</div>
                  <div class="box-content-right values box-no-pad-right">
                    {{
                      new Intl.NumberFormat("de-DE").format(
                        Math.round(campaign.real)
                      )
                    }}
                    &#8364;
                    <span>
                      &#40;{{
                        ((campaign.real * 100) / campaign.target).toFixed(0)
                      }}%&#41;</span
                    >
                  </div>
                </div>
              </div>
              <div v-else class="box-content-right values">
                <div class="flex-container">
                  <div class="box-content">Objetivo</div>
                  <div class="box-content-right values box-no-pad-right-top">
                    {{ campaign.target }}
                  </div>
                </div>
                <div class="flex-container">
                  <div class="box-content box-pad">Realizado</div>
                  <div class="box-content-right values box-no-pad-right">
                    {{ campaign.real }}
                    <span>
                      &#40;{{
                        ((campaign.real * 100) / campaign.target).toFixed(0)
                      }}%&#41;</span
                    >
                  </div>
                </div>
              </div>
              <hr class="hr-bottom" />

              <div v-if="isLeader">
                <div class="flex-container">
                  <div class="box-content">
                    <span class="smaller">Equipa</span>
                  </div>
                  <div class="box-content-right box-no-pad-right">
                    <span class="smaller">Contributo:</span>
                  </div>
                </div>
                <div
                  v-for="(dsr, dsrIndex) in campaign.dsr"
                  :key="dsrIndex"
                  class="dsr-box"
                >
                  <div class="flex-container">
                    <div class="box-content team-name">{{ dsr.name }}</div>
                    <div
                      v-if="campaign.name.includes('Niv')"
                      class="box-content-right values box-no-pad-right"
                    >
                      {{
                        new Intl.NumberFormat("de-DE").format(
                          Math.round(dsr.value)
                        )
                      }}
                      &#8364;
                    </div>
                    <div
                      v-else
                      class="box-content-right values box-no-pad-right"
                    >
                      {{ dsr.operators }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="flex-container">
                  <div class="box-content">
                    <span class="smaller">Individual</span>
                  </div>
                  <div
                    v-if="campaign.name.includes('Niv')"
                    class="box-content-right values box-no-pad-right"
                  >
                    {{
                      new Intl.NumberFormat("de-DE").format(
                        Math.round(campaign.user_result_value)
                      )
                    }}
                    &#8364;
                  </div>
                  <div v-else class="box-content-right values box-no-pad-right">
                    {{ campaign.user_result }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <h1>Página em desenvolvimento</h1>
    <p class="card in-development">Para aceder aos pedidos de resgate, por favor clique aqui: <router-link to="../pull">Pedidos de resgate</router-link><br> ou clique no menú no canto superior direito e selecione a opção que deseja.</p> -->
  </div>
  <div class="animated fadeIn" v-else-if="$auth.check(['dashboard.accounts'])">
    <div v-if="loading" class="overlay">
      <div><img class="spinner" src="loading.gif" alt="Loading data..." /></div>
    </div>
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="user" class="text-style">
      <h1 class="text-h1">Olá, {{ user }}</h1>
    </div>
    <div v-if="points" class="pad-bottom">
      <div class="text-style">
        <p class="upper small-title">Saldo em Pontos</p>
      </div>
      <div class="points-container">
        <div class="point-card-left">
          <div class="card-banner text-style">
            <span class="points-text"
              >Pontos <br />
              UFS</span
            >
            <div><img src="img/trophy-icon.png" alt="Trophy Icon" /></div>
          </div>
          <div class="card-points">
            {{ points.UFS }}
          </div>
        </div>
        <div class="point-card-right">
          <div class="card-banner text-style">
            <span class="points-text"
              >Pontos <br />
              Olá</span
            >
            <img src="img/medal-icon.png" alt="Medal Icon" />
          </div>
          <div class="card-points">
            {{ points.Ola }}
          </div>
        </div>
      </div>
    </div>

    <div class="text-style">
      <span class="upper small-title" id="al-left"
        >Indicadores de desempenho</span
      >
    </div>

    <!-- dropdown -->
    <div id="app">
      <MonthDropdown
        :selectedCampaignMonthFromParent="selectedCampaignMonth"
        @monthSelectedFilter="handleCampaignMonthSelected"
      />
    </div>

    <div id="app" class="app-camp">
      <div v-if="loading"></div>
      <div v-else-if="error">{{ error }}</div>
      <Slider v-else :items="campaignNames" v-model="selectedCampaign" />
    </div>
    <div v-if="selectedCampaignData.length > 0" class="campaign-container">
      <div
        v-for="(campaign, zIndex) in selectedCampaignData"
        :key="zIndex"
        class="campaign-box"
      >
        <div class="box">
          <div class="box-style text-style">
            <div class="text-box">
              <div class="box-content"><span class="smaller">Zona</span></div>
              <span class="box-content bigger">{{ campaign.zone }}</span>
              <div
                v-if="campaign.name.includes('Niv')"
                class="box-content-right values"
              >
                <div class="flex-container">
                  <div class="box-content">Objetivo</div>
                  <div class="box-content-right values box-no-pad-right-top">
                    {{
                      new Intl.NumberFormat("de-DE").format(
                        Math.round(campaign.target)
                      )
                    }}
                    &#8364;
                  </div>
                </div>
                <div class="flex-container">
                  <div class="box-content box-pad">Realizado</div>
                  <div class="box-content-right values box-no-pad-right">
                    {{
                      new Intl.NumberFormat("de-DE").format(
                        Math.round(campaign.real)
                      )
                    }}
                    &#8364;
                    <span>
                      &#40;{{
                        ((campaign.real * 100) / campaign.target).toFixed(0)
                      }}%&#41;</span
                    >
                  </div>
                </div>
              </div>
              <div v-else class="box-content-right values">
                <div class="flex-container">
                  <div class="box-content">Objetivo</div>
                  <div class="box-content-right values box-no-pad-right-top">
                    {{ campaign.target }}
                  </div>
                </div>
                <div class="flex-container">
                  <div class="box-content box-pad">Realizado</div>
                  <div class="box-content-right values box-no-pad-right">
                    {{ campaign.real }}
                    <span>
                      &#40;{{
                        ((campaign.real * 100) / campaign.target).toFixed(0)
                      }}%&#41;</span
                    >
                  </div>
                </div>
              </div>
              <hr class="hr-bottom" />
              <!-- DSR Information: Displayed only for zone leaders -->
              <div v-if="isLeader">
                <div class="flex-container">
                  <div class="box-content">
                    <span class="smaller">Equipa</span>
                  </div>
                  <div class="box-content-right box-no-pad-right">
                    <span class="smaller">Contributo:</span>
                  </div>
                </div>
                <div
                  v-for="(dsr, dsrIndex) in campaign.dsr"
                  :key="dsrIndex"
                  class="dsr-box"
                >
                  <div class="flex-container">
                    <div class="box-content team-name">{{ dsr.name }}</div>
                    <div
                      v-if="campaign.name.includes('Niv')"
                      class="box-content-right values box-no-pad-right"
                    >
                      {{
                        new Intl.NumberFormat("de-DE").format(
                          Math.round(dsr.value)
                        )
                      }}
                      &#8364;
                    </div>
                    <div
                      v-else
                      class="box-content-right values box-no-pad-right"
                    >
                      {{ dsr.operators }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="flex-container">
                  <div class="box-content">
                    <span class="smaller">Individual</span>
                  </div>
                  <div
                    v-if="campaign.name.includes('Niv')"
                    class="box-content-right values box-no-pad-right"
                  >
                    {{
                      new Intl.NumberFormat("de-DE").format(
                        Math.round(campaign.user_result_value)
                      )
                    }}
                    &#8364;
                  </div>
                  <div v-else class="box-content-right values box-no-pad-right">
                    {{ campaign.user_result }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Oportunidades -->

    <div class="text-style bg-filter">
      <!--add v-if="checkUserPermissions('dashboard')"-->
      <div class="side-by-filter">
        <span class="opportunities-title upper small-title">Oportunidades</span>
        <div id="app" class="filter-marg">
          <ProductMonthDropdown
            :selectedProductMonthFromParent="selectedProductMonth"
            @productMonthSelectedFilter="handleProductMonthSelected"
          />
        </div>
      </div>
    </div>

    <div id="opportunities-container" class="swiper-container scroll-container">
      <ProductSlider
        v-if="!loading && products.length > 0"
        :products="products"
        :get-image-url="getImageUrl"
        :handle-image-error="handleImageError"
        :isLeader="isLeader"
      />
    </div>

    <div class="flex-movement flex-container">
      <div class="flex-movement text-style">
        <span class="upper small-title">Movimento de pontos</span>
      </div>
      <div class="flex-movement">
        <select
          class="box-mov dp-container-select dropdown-list-select"
          v-model="selectedOption"
          @change="fetchPointsData"
        >
          <option class="dp-container-select" value="1">UFS</option>
          <option class="dp-container-select" value="2">OLA</option>
        </select>
      </div>
    </div>
    <div id="movpoints">
      <div class="card-list">
        <!-- Add ref with an array to the cards so we can access the first one -->
        <div
          v-for="(point, index) in visiblePoints"
          :key="index"
          class="card"
          ref="cards"
        >
          <div class="card-content">
            <p class="ym">{{ point.ym }}</p>
            <p class="description">{{ point.description }}</p>
            <p class="total-points">
              Valor <span class="value-points">{{ point.total_points }}</span>
            </p>
            <p class="total-points">
              Saldo:
              <span class="value-points">{{ getRunningBalance(index) }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-container">
      <div
        class="text-style see-more"
        v-if="visiblePoints.length < sortedPointsData.length"
      >
        <span class="upper small-title see-more" @click="loadMore"
          >Ver mais</span
        >
      </div>
      <div class="text-style see-less" v-if="hasLoadedMore">
        <span class="upper small-title see-less" @click="loadLess"
          >Ver menos</span
        >
      </div>
    </div>
    <div class="intro">
      <h2>FOLHETO E MONOFOLHAS</h2>
    </div>
    <div id="download">
      <div class="container-download">
        <div class="title"></div>
        <!-- {{this.docs}} -->
        <!-- Image preview -->
        <div v-if="imagePreview">
          <img
            :src="getImageUrl(imagePreview)"
            alt="PDF Preview"
            class="image-preview"
            @error="handleImageError"
          />
          <button @click="downloadPDF" class="btn btn-primary" v-if="pdfUrl">
            VER FOLHETO
          </button>
        </div>

        <!-- Image Preview for Single Sheet -->
        <div v-if="image_singlesheets">
          <img
            :src="getImageUrl(image_singlesheets)"
            alt="PDF Preview"
            class="image-preview"
            @error="handleImageError"
          />
          <button
            @click="downloadMono"
            class="btn btn-primary"
            v-if="pdfsinglesheet"
          >
            VER MONOFOLHA
          </button>
        </div>
      </div>
    </div>

    <div class="intro">
      <h2>FALE CONNOSCO</h2>
    </div>
    <div class="contact-container" id="container-contact">
      <!-- Message Section -->
      <div class="container">
        <div class="row align-items-center">
          <!-- Message Section -->
          <div class="col-md-10 col-10">
            <div class="message-section">
              <h2>Entre em contacto connosco</h2>
              <h2>Para sugestões ou reclamações</h2>
            </div>
          </div>
          <!-- Image Section -->
          <div class="col-md-2 col-2 text-right">
            <div class="image-section">
              <img
                src="contact-icon.png"
                alt="Contact Image"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Contact Us Button -->
      <div class="button-container">
        <button @click="openModal" class="btn btn-primary">Contactar</button>
      </div>
      <!-- Optional: Image on the right side -->
    </div>
    <!-- form Modal -->
    <div
      id="form-contact"
      class="modal-overlay"
      v-if="isModalOpen"
      @click="closeModal"
    >
      <div class="modal-content" @click.stop>
        <h2>FALE CONNOSCO</h2>
        <div class="modal-body">
          <form @submit.prevent="submitMessage">
            <div class="border-box">
              <label for="name">NOME</label>
              <div class="form-nome">{{ user }}</div>
              <!-- Display the name parameter -->
            </div>
            <div class="form-group">
              <textarea
                v-model="message"
                placeholder="MENSAGEM"
                class="form-control form-name"
              ></textarea>
            </div>

            <div class="form-group">
              <!--<input type="file" @change="handleFileUpload" class="form-control form-anexo" />-->
              <label for="fileUpload" class="btn btn-primary">
                {{ fileName ? "SUBSTITUIR IMAGEM" : "ANEXAR IMAGEM" }}
              </label>
              <input
                id="fileUpload"
                type="file"
                @change="handleFileUpload"
                class="hidden-file-input"
                accept="image/*"
                style="display: none"
              />
              <!-- Display selected file name if available -->
              <p v-if="fileName" class="file-name">{{ fileName }}</p>
            </div>
            <div class="form-group">
              <div class="container">
                <div class="row">
                  <!-- "Cancelar" Button Column -->
                  <div class="col-6 text-left">
                    <button
                      class="close-btn btn btn-secondary"
                      @click="closeModal"
                    >
                      CANCELAR
                    </button>
                  </div>
                  <!-- "Enviar" Button Column -->
                  <div class="col-6 text-right">
                    <button type="submit" class="btn btn-primary">
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Feedback Modal -->
    <div
      v-if="feedbackModal.show"
      class="modal-overlay"
      @click="closeFeedbackModal"
      id="form-feedback"
    >
      <div class="modal-content" @click.stop>
        <h2>{{ feedbackModal.title }}</h2>
        <p>{{ feedbackModal.message }}</p>
        <button @click="closeFeedbackModal" class="btn btn-primary">OK</button>
      </div>
    </div>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue@2.6.14/dist/vue.js"></script>
<script>
import Slider from "../components/Slider.vue";
import axios from "axios"; // Import axios here
import Vue from "vue";
import VModal from "vue-js-modal";
import "vue-js-modal/dist/styles.css";
import ProductSlider from "../components/ProductSlider.vue";

// If you need Navigation, Pagination modules
import MonthDropdown from "../components/MonthDropdown.vue";
import ProductMonthDropdown from "../components/ProductMonthDropdown.vue";

Vue.use(VModal);

export default {
  name: "App",
  components: {
    Slider,
    ProductSlider,
    MonthDropdown,
    ProductMonthDropdown,
  },
  name: "dashboard",

  data() {
    return {
      userRole: "pull",
      showModal: false,
      isModalOpen: false,
      feedbackModal: { show: false, title: "", message: "" },
      message: "",
      image: null,
      data: null,
      loading: true,
      selectedDate: "",
      selectedProductDate: null,
      user: null,
      points: null,
      campaigns: null,
      selectedCampaign: "",
      products: [],
      selectedOption: "1", // Default to "UFS"
      fileName: "", // Track the file name
      docs: null,
      visibleCards: 5,
      initialCards: 5,
      hasLoadedMore: false,
      isLeader: false,
      selectedCampaignMonth: null,
      selectedProductMonth: null,
      selectedZone: null,
      zones: [],
      starsSoCode: null,
      pointsData: [], // To store the list of points from API response
    };
  },
  computed: {
    saldo() {
      const saldoPoint = this.sortedPointsData.find(
        (point) =>
          point.description === "saldo UFS" || point.description === "saldo ola"
      );
      return saldoPoint ? parseFloat(saldoPoint.total_points) : 0;
    },

    visiblePoints() {
      return this.sortedPointsData.slice(0, this.visibleCards);
    },

    sortedPointsData() {
      // Convert the object to an array
      const pointsArray = Object.values(this.pointsData);

      // Sort the array by 'ym' in descending order
      return pointsArray.sort((a, b) => b.ym - a.ym); // For descending order
      // For ascending order, use: return pointsArray.sort((a, b) => a.ym - b.ym);
    },

    campaignNames() {
      // Extract unique campaign names from the list of campaigns
      if (!this.campaigns) return [];

      const names = this.campaigns.campaigns.map((campaign) => campaign.name);

      // Use Set to remove duplicates
      return [...new Set(names)];
    },
    selectedCampaignData() {
      // Returns an array of campaigns matching the selected name
      return this.campaigns
        ? this.campaigns.campaigns.filter(
            (campaign) => campaign.name === this.selectedCampaign
          )
        : [];
    },
  },
  async mounted() {
    // onesignal
    <link rel="manifest" href="manifest.json" />;
    const script = document.createElement("script");
    script.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
    script.defer = true;
    document.head.appendChild(script);
    OneSignalDeferred.push(async function (OneSignal) {
      await OneSignal.init({
        appId: "79bd762f-9218-4c95-b5b3-da5e2551d2fe",
      });
    });

    this.fetchName();
    this.fetchPoints();
    // this.fetchPullZones();
    this.starsSoCode = await this.fetchDsrId();
    await this.fetchPullZones(this.starsSoCode);

    if (this.starsSoCode === 0) {
      await this.fetchCampaings(); // Fetch right away for normal users
    }

    this.fetchProducts();
    this.fetchDocs();
    this.fetchPointsData();
    this.formatName();
    // this.fetchPullZones();
    // if (this.zones.length > 0) {
    //   this.selectedZone = this.zones[0]; // default to first
    //   this.fetchCampaings(); // trigger initial campaign load
    // }
    // this.isLeader = 1; //deve receber ser 0 ou 1 consoante o dsr_type

    //console.log("teste");

    await this.is_leader();

    //console.log(isLeader);

    // Simulate the current month data (default to the current month)
    const currentYear = new Date().getFullYear();
    const currentMonthIndex = new Date().getMonth(); // 0 = January

    const months = [
      ["Janeiro", "01", currentYear],
      ["Fevereiro", "02", currentYear],
      ["Março", "03", currentYear],
      ["Abril", "04", currentYear],
      ["Maio", "05", currentYear],
      ["Junho", "06", currentYear],
      ["Julho", "07", currentYear],
      ["Agosto", "08", currentYear],
      ["Setembro", "09", currentYear],
      ["Outubro", "10", currentYear],
      ["Novembro", "11", currentYear],
      ["Dezembro", "12", currentYear],
    ];
    // Get the current month details
    const currentMonth = months[currentMonthIndex];
    const formattedMonthYear = `${currentYear}${currentMonth[1]}`; // Example: '202409' for September 2024

    // Set the current month as selected
    this.selectedCampaignMonth = currentMonth;
    this.selectedProductMonth = currentMonth;
    this.selectedCampaignDate = formattedMonthYear;
    this.selectedProductDate = formattedMonthYear;

    // Call the handler to fetch the current month's data
    this.handleCampaignMonthSelected({
      teste: formattedMonthYear,
      selectedCampaignMonth: currentMonth,
    });

    this.handleProductMonthSelected({
      teste: formattedMonthYear,
      selectedProductMonth: currentMonth,
    });
  },

  methods: {
    formatName(fullName) {
      if (!fullName) return ""; // Retorna vazio se o nome não existir
      const names = fullName.trim().split(" ");
      if (names.length === 1) return names[0]; // Apenas um nome
      return `${names[0]} ${names[names.length - 1]}`; // Primeiro e último
    },

    handleCampaignMonthSelected({ teste, selectedCampaignMonth }) {
      this.selectedCampaignDate = teste;
      this.selectedCampaignMonth = selectedCampaignMonth;

      if (this.starsSoCode === 0 || this.selectedZone) {
        this.fetchCampaings();
      }
    },

    handleProductMonthSelected({ teste, selectedProductMonth }) {
      this.selectedProductDate = teste; // Update selected date (e.g., '202409')
      this.selectedProductMonth = selectedProductMonth; // Keep track of the selected month array
      // console.log('Selected Month:', selectedCampaignMonth);
      // console.log('Updated Selected Date:', this.selectedDate);

      // Fetch campaigns or update based on selected month
      this.fetchProducts();
    },

    checkUserPermissions(role) {
      const permissions = {
        pull: ["pull", "profile"],
        user: ["dashboard", "profile", "emissao"],
      };

      return (
        (permissions[this.userRole] &&
          permissions[this.userRole].includes(role)) ||
        false
      );
    },

    getRunningBalance(index) {
      // Start with saldoOla as the base
      let balance = this.saldo;

      // Sum the total_points up to the current index
      for (let i = this.sortedPointsData.length - 2; i >= index; i--) {
        balance += parseFloat(this.sortedPointsData[i].total_points);
      }

      return balance;
    },
    is_leader() {
      axios
        .get("app/is_leader")
        .then((response) => {
          if (response.status === 200) {
            const data = response.data; // Access the 'data' field
            this.isLeader = data;
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    loadMore() {
      // Increase the number of visible cards by 3
      this.visibleCards += 5;
      this.hasLoadedMore = true; // Mark that 'Ver mais' has been clicked
    },

    loadLess() {
      // Revert to the initial number of cards (3)
      this.visibleCards = this.initialCards;
      this.hasLoadedMore = false; // Reset the flag as 'Ver menos' is clicked

      this.$nextTick(() => {
        const firstCard = this.$refs.cards[0];
        if (firstCard) {
          // Get the vertical position of the first card relative to the top of the document
          const cardPosition =
            firstCard.getBoundingClientRect().top + window.scrollY;
          const offset = 150;

          // Scroll to the card's position with an offset, smoothly
          window.scrollTo({
            top: cardPosition - offset,
            behavior: "smooth",
          });
        }
      });
    },

    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    // selectMonth(index) {
    //   this.selectedMonth = this.months[index];
    //   this.selectedYear = this.currentYear;
    //   this.isOpen = false;
    // },

    getImageUrl(imageUrl) {
      // Check if the image URL is valid
      return imageUrl ? imageUrl : this.defaultImage();
    },

    defaultImage() {
      // Return the path to the default image
      return "default-product.png";
    },
    handleImageError(event) {
      event.target.src = "default-product.png";
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectCampaign(campaign) {
      this.selectedCampaign = campaign;
      this.isDropdownOpen = false;
    },

    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    triggerFileInput(event) {
      // Prevent default behavior and manually trigger the file input click
      event.stopPropagation();
      this.$refs.fileInput.click();
    },
    async fetchPointsData() {
      try {
        const response = await axios.get(
          `app/getBalancePoints/${this.selectedOption},${this.currentMonth}`
        );

        //console.log(response.data.data);

        // Extract data from the response
        if (response.status === 200 && response.data.data) {
          // Convert the object response to an array of values
          this.pointsData = response.data.data;
        } else {
          console.error("Failed to fetch data:", response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchDocs() {
      try {
        this.loading = true;
        this.error = null;
        this.docs = null;

        const response = await this.axios.get(
          `app/getDocs/${this.currentMonth}`
        );

        if (response.status === 200 && response.data.data) {
          this.docs = response.data.data;
          this.loading = false;

          if (this.docs.length > 0) {
            const firstItem = this.docs[0];
            this.imagePreview = firstItem.image_pdfleaflets;
            // this.imagePreview = "https://inpar-produtos-v2.s3.eu-west-1.amazonaws.com/campanhas/teste/tumbnail.png";
            this.pdfUrl = firstItem.pdfleaflets;
            // this.pdfUrl = "https://inpar-produtos-v2.s3.eu-west-1.amazonaws.com/campanhas/teste/folheto.pdf";
            this.image_singlesheets = firstItem.image_singlesheets;
            // this.image_singlesheets = "https://inpar-produtos-v2.s3.eu-west-1.amazonaws.com/campanhas/teste/monofolha_teste.jpg";
            this.pdfsinglesheet = firstItem.pdfsinglesheet;
            // this.pdfsinglesheet = "https://inpar-produtos-v2.s3.eu-west-1.amazonaws.com/campanhas/teste/monofolha_teste.jpg";
          }
        } else {
          console.error("Failed to fetch data:", response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    downloadPDF() {
      if (this.pdfUrl) {
        const a = document.createElement("a");
        a.href = this.pdfUrl;
        a.download = "document.pdf"; // Default filename
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },
    downloadMono() {
      if (this.pdfsinglesheet) {
        const a = document.createElement("a");
        a.href = this.pdfsinglesheet;
        a.download = "document.pdf"; // Default filename
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        // Validate file type
        if (!file.type.startsWith("image/")) {
          alert("Please select a valid image file.");
          this.file = null;
          this.image = null;
          return;
        }

        // Create a URL for the selected file for preview
        this.image = URL.createObjectURL(file);
        // Store the file object for submission
        this.file = file;
      } else {
        // Reset the image and file if no file is selected
        this.image = null;
        this.file = null;
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        console.log("File selected:", file);
        console.log("File name:", file.name);
        console.log("File type:", file.type);
        console.log("File size (bytes):", file.size);
        this.image = file;
        this.fileName = file.name;
        console.log("passei aqui");
      } else {
        this.fileName = "";
      }
    },

    async submitMessage() {
      const formData = new FormData();
      formData.append("message", this.message);
      if (this.image) {
        console.log("Attaching image to form:", this.image);
        formData.append("image", this.image); // Add the image file to the form data
      }
      console.log("Message:", this.message);
      console.log("FormData content:", formData);

      try {
        const response = await axios.post("app/getContact", formData, {
          headers: {},
        });

        console.log("Response from server:", response);

        if (response.data.success) {
          this.showFeedbackModal(
            "Sucesso",
            "Obrigado por submeter a sua mensagem. Será respondido o mais brevemente possível."
          );
        } else {
          this.showFeedbackModal(
            "Erro",
            "Erro ao enviar a mensagem. Tente novamente!"
          );
        }
        this.clearFormData();
      } catch (error) {
        console.error("Erro ao enviar a mensagem:", error);
        if (error.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error response status:", error.response.status);
          console.error("Error response headers:", error.response.headers);
        }
        this.showFeedbackModal(
          "Erro",
          "Ocorreu um erro ao enviar a mensagem. Tente novamente mais tarde!"
        );
        this.clearFormData();
      }
    },

    showFeedbackModal(title, message) {
      this.feedbackModal.title = title;
      this.feedbackModal.message = message;
      this.feedbackModal.show = true;
    },
    closeFeedbackModal() {
      this.feedbackModal.show = false;
    },
    clearFormData() {
      this.message = "";
      this.image = null;
      this.fileName = "";
    },
    fetchName() {
      this.loading = true;
      this.error = null;
      this.user = null;

      this.axios
        .get("app/getInfo")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.user = response.data.name;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },
    async fetchPoints() {
      try {
        this.loading = true;
        this.error = null;
        this.points = null;
        this.pointsUfs = 0;
        this.pointsOla = 0;

        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0"); // Get month (0-based index, so add 1)
        this.currentMonth = `${year}${month}`;

        const responseufs = await axios.get(
          `app/getPointsUfsHistoric/${this.currentMonth}`
        );

        //console.log(response.data);

        // Extract data from the response
        if (responseufs.status === 200 && responseufs.data.data) {
          // Convert the object response to an array of values
          this.pointsUfs = responseufs.data;
          //console.log(this.pointsData);
        } else {
          console.error("Failed to fetch data:", responseufs);
        }

        const responseola = await axios.get(
          `app/getPointsOlaHistoric/${this.currentMonth}`
        );

        //console.log(response.data);

        // Extract data from the response
        if (responseola.status === 200 && responseola.data.data) {
          // Convert the object response to an array of values
          this.pointsOla = responseola.data;
          //console.log(this.pointsData);
        } else {
          console.error("Failed to fetch data:", responseola);
        }

        this.points = { UFS: responseufs.data, Ola: responseola.data };
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    async fetchCampaings() {
      // if (this.starsSoCode !== 0 && !this.selectedZone) {
      //   console.warn('Zone not selected and user is not allowed to fetch by default');
      //   return;
      // }

      this.loading = true;
      this.campaigns = null;
      this.error = null;

      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Get month (0-based index, so add 1)
      this.currentMonth = `${year}${month}`;
      const selector = this.selectedCampaignDate;
      let zoneParam = this.selectedZone;

      const response = await axios.get(
        `app/getCampaigns/${selector},${zoneParam}`
      );

      if (response.status === 200 && response.data) {
        // Convert the object response to an array of values
        this.campaigns = response.data;

        //console.log(this.pointsData);
      } else {
        console.error("Failed to fetch data:", response);
      }

      this.selectedCampaign = this.campaignNames[0];
      this.loading = false;

      console.log("Fetching campaigns for date:", this.selectedDate);
    },
    async fetchProducts() {
      this.loading = true;
      this.products = null;
      const selector = this.selectedProductDate;

      try {
        const response = await axios.get(`app/getCriterias/${selector}`);
        if (response.status === 200 && response.data) {
          this.products = response.data.data;
        } else {
          console.error("Failed to fetch product data");
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchDsrId() {
      try {
        const response = await axios.get("app/getDsrId");

        return response.data.stars_so_code;
      } catch (error) {
        console.error("Error fetching DSR ID:", error);
        return null;
      }
    },

    async fetchPullZones(starsSoCode) {
      this.loading = true;

      try {
        if (!starsSoCode) throw new Error("No stars_so_code received");

        const response = await axios.get(`app/getLeaders/${starsSoCode}`);
        if (response.status === 200 && response.data) {
          this.zones = response.data;
        } else {
          console.error("Failed to fetch zones");
        }
      } catch (error) {
        console.error("Error fetching zones:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.in-development {
  padding: 30px;
}

.team-name {
  font-size: 16px;
  padding-top: 5px !important;
  padding-bottom: 10px !important;
}

.filter-marg {
  margin-right: 30px !important;
}

.bg-filter {
  background-color: #ffe3c9;
  margin-right: -30px;
}

.side-by-filter {
  display: flex;
  justify-content: space-between;
}

.container-fluid {
  padding: 0px 20px !important;
}

.container-fluid img {
  padding-left: 0px !important;
}

.month-menu {
  font-size: 18px;
}

.month-border {
  border: 1px solid #f48c4f !important;
}

.small-title {
  font-size: 16px;
  font-weight: 500;
  font-family: Arial, Helvetica, sans-serif;
}

.bold {
  font-weight: 500;
}

.error {
  color: red;
}

.dp-container-select {
  font-family: Arial, sans-serif;
  cursor: pointer;
  position: relative;
}

.app-header .nav-item .nav-link {
  margin-right: 30px;
}

.breadcrumb {
  display: none;
}

.dropdown-list-select {
  background-color: white;
  border: 1px solid #f48c4f !important;
  border-radius: 12px;
  max-height: 200px;
  overflow-y: auto;
  /* z-index: 1000; */
  font-size: 18px;
}

.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .flex-movement {
    padding-bottom: 20px;
  }

  .flex-right {
    text-align: right;
    padding-right: 20px;
  }

  .flex-left {
    text-align: right;
  }
}

.see-less {
  display: flex;
  text-align: right;
  font-weight: 500;
  font-size: 16px;
}

.see-more {
  display: flex;
  color: #f48c4f;
  text-align: left;
  font-weight: 500;
  font-size: 16px;
}

.pad-bottom {
  padding-bottom: 40px;
}

.text-style {
  .upper {
    text-transform: uppercase;
    font-weight: bold;
  }

  .text-h1 {
    color: #f47325;
    margin-bottom: 40px;
    margin-top: 40px;
  }

  .points-text {
    line-height: 23.22px;
    font-size: 18px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
  }

  .text-box {
    color: #000000b3;
    line-height: 22.93px;
    font-size: 18px;
    font-weight: 400;

    .smaller {
      font-size: 16px;
      line-height: 20.38px;
      color: #00000080;
    }

    .bigger {
      font-size: 24px;
      font-weight: 500;
      line-height: 30.96px;
    }

    .values {
      font-weight: 500;
    }
  }
}

.box-mov {
  padding: 10px;
}

.hr-bottom {
  margin-bottom: 0px;
}

.box {
  padding-bottom: 30px;

  .box-style {
    border-radius: 12px;
    border: 1px solid #e7d9d0;
    background-color: #fff;
  }

  .box-content {
    padding: 15px 0px 10px 20px;
  }

  .box-no-pad {
    padding: 15px 0px 0px 20px !important;
  }

  .box-no-pad-right {
    padding: 0px 20px 0px 0px !important;
  }

  .box-no-pad-right-top {
    padding: 15px 20px 0px 0px !important;
  }

  .box-pad {
    padding: 5px 0px 0px 20px;
  }

  /* .box-content-right {
    padding-right: 20px;
  } */
}

.box-min-height {
  min-height: 50px;
}

.white_bg_logo {
  /* background-color: #fff;
  
  margin-left: -30px; 
  margin-right: -15px; 
  padding-left: 25px; 
  padding-right: 15px; 
  width: calc(100% + 30px); */
  margin-bottom: 40px;

  .logo_width {
    width: 64px;
  }
}

.points-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.point-card-left {
  background: linear-gradient(to right, #f36f25, #f99e22);
  color: white;
  padding: 15px;
  border-radius: 12px;
  width: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: left;
}

.point-card-right {
  background: linear-gradient(to right, #af3f00, #c26e00);
  color: white;
  padding: 15px;
  border-radius: 12px;
  width: 50%;
  text-align: left;
}

.card-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}

.points-text {
  text-align: left;
  display: inline-block;
  margin-right: 10px;
}

.card-banner img {
  width: 24px;
  height: 24px;
  align-self: flex-start;
  padding: 0px;
}

.card-banner img {
  width: 40px;
  height: 40px;
}

.card-points {
  font-size: 32px;
  font-weight: 400;
  margin-top: 5px;
  line-height: 40.77px;
}

.app-camp {
  margin: 20px 0px 20px 0px !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 30px 0px 10px 0px;
  scrollbar-width: none !important;
  /* Oculta a barra de rolagem */
}

#app::-webkit-scrollbar {
  display: none !important;
  /* Para Chrome, Safari e outros navegadores baseados em WebKit */
}

#al-left {
  float: left;
  padding-left: 0px;
}

#al-right {
  text-align: right;
  float: right;
}

.scroll-container::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, e outros navegadores WebKit */
}

#opportunities-container {
  display: flex;
  justify-content: space-between;
  padding: 10px 0px 40px 30px;
  background-color: #ffe3c9;
  margin-left: -30px;
  margin-right: -30px;
  margin-bottom: 40px;
  scrollbar-width: none;
  /* Firefox */
}

.opportunities-title {
  display: block;
  text-align: left;
  background-color: #ffe3c9;
  padding: 40px 0px 0px 30px;
  margin-left: -30px;
  margin-right: -30px;
}

.opportunity-item {
  background-color: #fff;
  border-radius: 12px;
  text-align: center;
  padding: 15px;
  max-width: 196px;
  min-height: 256px;
  border: 1px solid #e7d9d0;
}

.product-image {
  max-width: 100px;
  height: 100px;
  margin-bottom: 30px;
}

.swiper-slide {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.product-name {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  height: 3em;
  /* Adjust this value as needed */
  line-height: 1.5em;
  /* Adjust this to match the height of each line of text */
  overflow: hidden;
  /* Hide overflow text */
  text-overflow: ellipsis;
  /* Add ellipsis (...) at the end of the text if it overflows */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Limits the number of lines to 3 */
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  /* Break words if necessary */
  margin-bottom: auto;
  /* Pushes the product-points to the bottom */
}

.points-pad {
  margin: 15px 0px 10px 0px;
}

.individual-units {
  font-size: 1rem;
  font-weight: bold;
  background-color: #fff;
  padding: 5px 10px;
  text-align: center;
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 14px;
}

.product-points {
  font-size: 1rem;
  color: #333;
  padding: 5px 10px;
  text-align: center;
  background-color: #f47325;
  color: white;
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 14px;
}

#form-contact .form-group {
  margin-bottom: 15px;
}

#form-contact .form-name {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  height: auto;
  min-height: 20vh;
}

#form-contact .form-anexo {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  height: auto;
  min-height: 2vh;
}

#form-contact .btn {
  padding: 10px 20px;
  font-size: 14px;
}

#form-contact .form-nome {
  margin-top: -10px;
}

#form-contact .modal-container {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  max-width: 500px;
}

#form-contact .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#form-contact .modal-title {
  margin: 0;
}

#form-contact .close {
  cursor: pointer;
}

#form-contact .modal-body {
  padding: 0 0;
  padding-top: 20px;
}

#form-contact h2 {
  font-size: 16px;
  margin-top: 5px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

#form-contact .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 500px;
  width: 90%;
  margin: auto;
}

#form-contact .close-btn {
  color: #c26e00;
  border: none;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: none;
  cursor: pointer;
}

#form-contact .custom-file-upload {
  position: relative;
  display: inline-block;
}

#form-contact .custom-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

#form-contact .border-box {
  border: 1px solid #e4e7ea;
  border-radius: 5px;
  padding: 10px;
  /*background-color: #f8f9fa;*/
  margin-bottom: 20px;
  font-size: 16px;
}

#form-contact .custom-file-upload label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.intro h2 {
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
}

#container-contact {
  background: linear-gradient(240.74deg, #c26e00 0%, #af3f00 100%);
  border-radius: 15px;
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
}

#container-contact .contact-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

#container-contact .message-section {
  flex: 1;
  /*padding-right: 20px;*/
  padding: 5px 5px 5px 5px;
}

#container-contact .image-section {
  /*flex: 0.3;
  text-align: right;*/
  width: max-content;
}

#container-contact .image-section img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

#container-contact .btn-primary {
  background-color: #fff;
  color: #f48c4f;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
}

#container-contact .btn-primary:hover {
  background-color: #f48c4f;
  color: #fff;
}

#form-contact .btn-primary {
  background-color: #f48c4f;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 100%;
}

#form-contact .custom-file-upload {
  position: relative;
  display: inline-block;
}

#form-contact .custom-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

#form-contact .custom-file-upload label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: center;
}

#form-contact .btn-primary:hover {
  background-color: #c26e00;
  color: #fff;
}

#container-contact h2 {
  color: #fff;
  font-size: 16px;
}

#container-contact p {
  color: #666;
  font-size: 16px;
}

#container-contact .button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

#form-feedback .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

#form-feedback .modal-content h2 {
  margin-top: 0;
}

#form-feedback .btn {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #f48c4f;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#form-feedback .btn:hover {
  background-color: #c26e00;
  color: #fff;
}

#download .container-download {
  padding: 10px 20px;
  background-color: #f48c4f;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  border-radius: 15px;
  /*margin-bottom: 25px;
  margin-top: 25px;*/
}

#download .image-preview {
  width: 100%;
  border-radius: 15px;
}

#download .title {
  margin-top: 20px;
  margin-bottom: 20px;
}

#download .btn-primary {
  background-color: #fff;
  color: #c26e00;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 60%;
  margin-top: 30px;
  text-transform: uppercase;
  margin-left: 20%;
  margin-right: 20%;
  margin-bottom: 30px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

/* Spinner or loading message */
.spinner {
  width: 80px;
  height: 80px;
  text-align: center;
}

#download .btn-primary:hover {
  background-color: #f48c4f;
  color: #fff;
}

#movpoints .card-list {
  display: block;
  width: 100%;
}

#movpoints .card {
  /*width: 300px;*/
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

#movpoints .card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#movpoints .description {
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 18px;
  text-transform: capitalize;
}

#movpoints .ym,
.total-points {
  color: #555;
  margin-top: 0px;
  margin-bottom: 0px;
}

#movpoints .total-points {
  color: #555;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 18px;
}

#movpoints .ym {
  color: #555;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 16px;
}

#movpoints .value-points {
  font-weight: bold;
  position: absolute;
  right: 30px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: 18px;
}

/* @media (max-width: 767px) {
  body {
    overflow-y: auto !important;
    height: 100vh; 
    scrollbar-width: none !important; 
  }
  
  body::-webkit-scrollbar {
    display: none !important; 
  }
} */

body {
  margin: 0;
  padding: 0;
  height: 100vh;
  /* Garante que ocupe toda a altura da tela */
}

.container-pull-zone {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#zoneSelect {
  padding: 5px 10px;
  border: 1px solid #f48c4f;
  border-radius: 12px;
  font-size: small;
  text-align: center;
}
</style>
